/**
 * @flow
 */

import React, { Component } from 'react';
import gql from 'graphql-tag';
import { useMutation } from '@apollo/client';
import { useSelector } from 'react-redux';
import { connect } from 'react-redux';
import { DropTarget } from 'react-dnd';
import { Column } from '../../../../components/timetable';
import {
    CELL_HEIGHT_PX,
    CELL_STEP,
} from '../../../../components/timetable/Cell';
import { offsetToTime } from '../../../../lib/schedule';
import { format } from 'date-fns';
import { get } from 'lodash';

import { APPOINTMENT_FRAGMENT } from '../../containers/queries';

const UPDATE_APPOINTMENT_QUERY = gql`
    mutation updateAppointment(
        $input: UpdateAppointmentInput!
        $salon: ID!
        $lang: String!
    ) {
        updateAppointment(input: $input) {
            appointment {
                id
                ...appointment
            }
        }
    }

    ${APPOINTMENT_FRAGMENT}
`;

class AppointmentColumnInner extends Component {
    render() {
        const { connectDropTarget } = this.props;
        return connectDropTarget(
            <div>
                <Column {...this.props} />
            </div>,
        );
    }
}

// Specify the drop target contract
const target = {
    drop: (props, monitor, component) => {
        const { appointment } = monitor.getItem();

        const time = offsetToTime(
            appointment.startAt,
            props.cellHeight,
            CELL_STEP,
            monitor.getDifferenceFromInitialOffset().y,
            props.schedule.step,
        );

        props.onDrop({
            appointment: appointment,
            master: props.inCabinet ? appointment.master : props.provider,
            cabinet: props.inCabinet ? props.provider : appointment.cabinet,
            startAt: time,
        });
    },
};

// Specify which props inject into component
const collect = (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
});

const mapStateToPropsInner = ({ appointments }) => ({
    cellHeight: appointments.get('cellHeight') || CELL_HEIGHT_PX,
});

const AppointmentColumnDnD = connect(mapStateToPropsInner)(
    DropTarget('APPOINTMENT', target, collect)(AppointmentColumnInner),
);

const AppointmentColumn = (props) => {
    const salon = useSelector(({ user }) => user.get('salon'));
    const showArchive = useSelector(({ salon: salonState }) => salonState.get('showArchive'));
    const currentLanguage = useSelector(({ intl }) => intl.get('locale') || intl.get('defaultLanguage'));

    const [updateAppointmentMutation] = useMutation(UPDATE_APPOINTMENT_QUERY);

    const onDrop = data => {
        const paid = data.appointment.invoice //
            ? data.appointment.invoice.paid
            : null;

        if (!paid) {
            const master = get(data, 'master.id');
            const cabinet = props.inCabinet
                ? get(data, 'cabinet.id')
                : null;
            const mutation = updateAppointmentMutation({
                variables: {
                    input: {
                        appointmentId: data.appointment.id,
                        master,
                        cabinet,
                        client: data.appointment.client.id,
                        startAt: format(new Date(data.startAt), 'yyyy-MM-dd HH:mm'),
                        notes: data.appointment.notes,
                    },
                    salon,
                    lang: currentLanguage,
                },
                update: (store, { data: { updateAppointment } }) => {
                    if (props.updateAppointment) {
                        props.updateAppointment(
                            updateAppointment.appointment,
                        );
                    }
                },
            });

            return mutation;
        }
    };

    return (
        <AppointmentColumnDnD
            {...props}
            salon={salon}
            showArchive={showArchive}
            currentLanguage={currentLanguage}
            onDrop={onDrop}
        />
    );
};

export default AppointmentColumn;
